export enum AddVersionType {
  Version = 'VERSION',
  ArtAsset = 'ASSET',
}

export enum QIResultStatus {
  WAITING = 'WAITING', // 已经上传，等待质检开始,
  PROCESSING = 'PROCESSING', // '正在质检',
  FINISH = 'FINISH', // '质检完成',
  UPLOAD_PROCESSING = 'UPLOAD_PROCESSING', //'正在生成版本',
  UPLOAD_SUCCESS = 'UPLOAD_SUCCESS', // '提交成功',
  UPLOAD_ERROR = 'UPLOAD_ERROR', // '提交版本网络异常',
  UPLOADING = 'UPLOADING', // 版本文件正在上传',前端用
  WAITING_UPLOADING = 'WAITING_UPLOADING', // 版本文件在暂存区，未上传',前端用
  REPLACING_FILES = 'REPLACING_FILES', // 替换异常文件中, 前端用
  UPLOADING_ERROR = 'UPLOADING_ERROR', // 上传文件网络异常, 前端用
}
export enum QIDetailStatus {
  SUCCESS = 'SUCCESS', // '质检通过',
  FILE_WARNING = 'FILE_WARNING', // '文件告警', // 正在质检和质检完成都会存在此状态
  FILE_ERROR = 'FILE_ERROR', // '文件异常',
  SERVER_ERROR = 'SERVER_ERROR', //'质检异常',
}

// 任务队列的状态数据结构
export interface TaskQueueStatus {
  result: QIResultStatus;
  detail?: QIDetailStatus;
  message?: any[];
  queuePos?: number;
}

export interface TaskMessage {
  taskId: number;
  uuid: string;
  fileId?: string;
  taskProgress: string;
  fileProgress: string;
  taskStatus?: TaskQueueStatus;
  fileStatus?: TaskQueueStatus;
  fosFileId?: string; // fos文件id
  isReplaced?: boolean; // 是否替换文件，对应fileId
}
export interface TaskQueueDetail {
  taskId: number;
  uuid: string;
  taskName?: string;
  taskStatus: TaskQueueStatus;
  fileStatus: TaskQueueStatus;
  preview?: string; //父任务缩略图
  taskProgress?: string;
  description?: string;
  attachments?: string;
  queuePos?: number; //排队的位置
  fileList?: TaskFileDetail[]; //一个任务包含的文件列表
  type: AddVersionType;
}
//质检过程中的文件信息，样式用来还原提交文件的信息
export interface TaskFileDetail {
  path: string; //文件路径
  fileId: string;
  fileName: string;
  size: number;
  format: string;
  fileStatus?: TaskQueueStatus; // 文件质检状态
  fileProgress?: string; // 上传进度
  isReplaced?: boolean; // 是否替换
  fosFileId?: string; // fos文件id
  info?: Record<string, any>; // 文件元信息
}
export const mapQIStatusToText = (taskStatus: QIResultStatus, fileStatus: QIResultStatus) => {
  switch (taskStatus) {
    case QIResultStatus.WAITING:
      return '等待开始';
    case QIResultStatus.PROCESSING:
      return '正在质检';
    case QIResultStatus.FINISH:
      return '待确认提交';
    case QIResultStatus.UPLOAD_PROCESSING:
      return '正在生成版本';
    case QIResultStatus.UPLOAD_SUCCESS:
      return '提交完成';
    case QIResultStatus.UPLOAD_ERROR:
      return '网络异常';
    case QIResultStatus.UPLOADING:
      if (fileStatus === QIResultStatus.UPLOAD_ERROR) {
        return '上传失败';
      }
      return '正在上传';
    case QIResultStatus.WAITING_UPLOADING:
      return '未开始上传';
    default:
      return '';
  }
};
export const mapQISubStatusToText = (status: QIDetailStatus) => {
  switch (status) {
    case QIDetailStatus.FILE_ERROR:
      return '文件异常';
    case QIDetailStatus.FILE_WARNING:
      return '文件告警';
    case QIDetailStatus.SUCCESS:
      return '质检通过';
    case QIDetailStatus.SERVER_ERROR:
      return '质检异常';
    default:
      return '';
  }
};
